import { Swiper } from "swiper/types";
import { AutoFocusInside } from "react-focus-on";
import Modal from "../../stories/Components/Modal";
import {
    ModalTypes,
    ModalWithSliderProps,
} from "../../stories/Components/Modal/interface";
import { TransformedCardData } from "../../stories/Components/Card/interface";
import PersistentPlayerPlaceholder from "../PersistentPlayer/components/Placeholder/component";
import styles from "./videoModal.module.scss";
import { isCMPVisible } from "../../utils/cmp/library";
import { VIDEO_ASPECT_RATIOS } from "./constants";
const typedIsCMPVisible = isCMPVisible as () => boolean;

interface VideoModalItem extends TransformedCardData {
    featureAttributionPosition?: number;
}

interface VideoModalProps {
    isOpen: boolean;
    items: VideoModalItem[];
    playingVideoIndex: number;
    onSlideChange?: (swiper: Swiper) => void;
    onSwiper?: (swiper: Swiper) => void;
    handleClose: () => void;
    aspectRatio: string;
    featureAttributionName?: string;
    shouldDisableAds?: boolean;
}

const VideoModal = ({
    isOpen,
    items = [],
    playingVideoIndex,
    onSlideChange,
    handleClose,
    onSwiper,
    aspectRatio = VIDEO_ASPECT_RATIOS["16x9"],
    featureAttributionName,
    shouldDisableAds = false,
}: VideoModalProps) => {
    const renderPlaceholders = () => {
        return items.map((item: VideoModalItem, index: number) => {
            const isPlaying = index === playingVideoIndex;

            const mediaItem: VideoModalItem = item;
            const config = {
                autoPlay: isPlaying,
                forcePersistence: false,
                routeUpdate: false,
                useMediaAspectRatio: false,
                disablePersistence: true,
                hideFullscreenBtn: true,
                aspectRatio,
            };

            const mediaDataOverrides = {
                thumbnail:
                    aspectRatio === VIDEO_ASPECT_RATIOS["9x16"]
                        ? mediaItem.image?.aspects?.ratio9x16?.url || ""
                        : mediaItem.image?.aspects?.ratio16x9?.url || "",
                shouldDisableAds,
            };

            const featureAttribution = {
                name: featureAttributionName,
                position: item?.featureAttributionPosition || index + 1, // CQW card-grid with videos need to be tracked based on their position in the lineup
            };

            const wrapperClasses =
                aspectRatio === "9:16"
                    ? styles.verticalVideoWrapper
                    : styles.horizontalVideoWrapper;

            if (isPlaying) {
                return (
                    <div
                        className={wrapperClasses}
                        key={`video-modal-${index}`}
                    >
                        <AutoFocusInside>
                            <PersistentPlayerPlaceholder
                                config={config}
                                mediaItem={mediaItem}
                                mediaDataOverrides={mediaDataOverrides}
                                disableRecommendations={true}
                                featureAttribution={featureAttribution}
                            />
                        </AutoFocusInside>
                    </div>
                );
            }

            return (
                <div className={wrapperClasses} key={`video-modal-${index}`}>
                    <img
                        className={styles.thumbnail}
                        src={mediaDataOverrides.thumbnail}
                        alt=""
                    />
                </div>
            );
        });
    };

    const propsForModalType: ModalWithSliderProps = {
        onSlideChange: onSlideChange,
        initialSlide: playingVideoIndex,
        onSwiper: onSwiper,
    };

    return (
        <Modal
            type={ModalTypes.MODAL_WITH_SLIDER}
            isOpen={isOpen}
            handleClose={handleClose}
            propsForModalType={propsForModalType}
            enableFocusTrap={!typedIsCMPVisible()}
            enableScrollLock={false}
        >
            {renderPlaceholders()}
        </Modal>
    );
};

export default VideoModal;
